import Helper from "../../Helper";

export function claimTV(connect_code: string): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain("api")}/fire_tv/claim/${connect_code}`;
    const options = {
        method: "put",
        body: JSON.stringify({}),
    };
    return Helper.plotFetch(url, options, true)
        .then((data) => {
            if (data.ok) {
                return data.json();
            }

            return null;
        })
        .then((data) => {
            return data;
        })
        .catch(() => {
            return null;
        });
}
